var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadBookingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.4C0 4.15979 0 3.03969 0.435974 2.18404C0.819467 1.43139 1.43139 0.819467 2.18404 0.435974C3.03969 0 4.15979 0 6.4 0H39.6C41.8402 0 42.9603 0 43.816 0.435974C44.5686 0.819467 45.1805 1.43139 45.564 2.18404C46 3.03969 46 4.15979 46 6.4V39.6C46 41.8402 46 42.9603 45.564 43.816C45.1805 44.5686 44.5686 45.1805 43.816 45.564C42.9603 46 41.8402 46 39.6 46H6.4C4.15979 46 3.03969 46 2.18404 45.564C1.43139 45.1805 0.819467 44.5686 0.435974 43.816C0 42.9603 0 41.8402 0 39.6V6.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 17H15C14.4477 17 14 17.4477 14 18V31C14 31.5523 14.4477 32 15 32H31C31.5523 32 32 31.5523 32 31V18C32 17.4477 31.5523 17 31 17Z",
    stroke: "#1447B1",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.975 23.004H25.975M14 17.5L17.5 13.5H28.5L32 17.5",
    stroke: "#1447B1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadBookingIcon);
export default __webpack_public_path__ + "static/media/load_booking_icon.30ba159d36104cd1820b279c674513b2.svg";
export { ForwardRef as ReactComponent };